// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.active-modal {
  overflow-y: hidden;
}

.btn-modal {
  padding: 10px 20px;
  display: block;
  margin: 100px auto 0;
  font-size: 18px;
}

.modal,
.overlay {
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  z-index: 11;
}

.overlay {
  background: rgba(49, 49, 49, 0.8);
  height: 100vh;
}
.modal-content {
  position: absolute;
  top: 43%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 1.4;
  background: white;
  border-radius: 3px;
  max-width: 600px;
  z-index: 12;
  overflow-y: auto;
}
@media (min-width: 500px) {
  .modal-content {
    width: 80%;
  }
  .modal-image {
    max-height: 64vh !important;
  
  }
}

@media (min-width: 450px) and (max-width: 500px) {
  .modal-content {
    width: 100%;
  }
  .modal-image {
    max-height: 50vh !important;
  }
}

@media (min-width: 360px) and (max-width: 450px) {
  .modal-content {
    width: 100%;
  }
  .modal-image {
    max-height: 42vh !important;
  }
}

@media (min-width: 330px) and (max-width: 360px) {
  .modal-content {
    width: 100%;
  }
  .modal-image {
    max-height: 36vh !important;
  }
}

@media (min-width: 300px) and (max-width: 330px) {
  .modal-content {
    width: 100%;
  }
  .modal-image {
    max-height: 36vh !important;
  }
}

@media (min-width: 200px) and (max-width: 300px) {
  .modal-content {
    width: 100%;
  }
  .modal-image {
    max-height: 36vh !important;
  }
}
.close-modal {
  position: absolute;
  top: 20px;
  right: 30px;
  padding: 5px 7px;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  transition: 0.3s;
}
.close-modal:hover {
  background-color: rgba(0, 0, 0, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/assets/Modal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,2BAA2B;;EAE7B;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,oCAAoC;AACtC","sourcesContent":["body.active-modal {\n  overflow-y: hidden;\n}\n\n.btn-modal {\n  padding: 10px 20px;\n  display: block;\n  margin: 100px auto 0;\n  font-size: 18px;\n}\n\n.modal,\n.overlay {\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  position: fixed;\n  z-index: 11;\n}\n\n.overlay {\n  background: rgba(49, 49, 49, 0.8);\n  height: 100vh;\n}\n.modal-content {\n  position: absolute;\n  top: 43%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  line-height: 1.4;\n  background: white;\n  border-radius: 3px;\n  max-width: 600px;\n  z-index: 12;\n  overflow-y: auto;\n}\n@media (min-width: 500px) {\n  .modal-content {\n    width: 80%;\n  }\n  .modal-image {\n    max-height: 64vh !important;\n  \n  }\n}\n\n@media (min-width: 450px) and (max-width: 500px) {\n  .modal-content {\n    width: 100%;\n  }\n  .modal-image {\n    max-height: 50vh !important;\n  }\n}\n\n@media (min-width: 360px) and (max-width: 450px) {\n  .modal-content {\n    width: 100%;\n  }\n  .modal-image {\n    max-height: 42vh !important;\n  }\n}\n\n@media (min-width: 330px) and (max-width: 360px) {\n  .modal-content {\n    width: 100%;\n  }\n  .modal-image {\n    max-height: 36vh !important;\n  }\n}\n\n@media (min-width: 300px) and (max-width: 330px) {\n  .modal-content {\n    width: 100%;\n  }\n  .modal-image {\n    max-height: 36vh !important;\n  }\n}\n\n@media (min-width: 200px) and (max-width: 300px) {\n  .modal-content {\n    width: 100%;\n  }\n  .modal-image {\n    max-height: 36vh !important;\n  }\n}\n.close-modal {\n  position: absolute;\n  top: 20px;\n  right: 30px;\n  padding: 5px 7px;\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n  transition: 0.3s;\n}\n.close-modal:hover {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
